/**
 * Application Configuration
 * Email addresses and other static configuration values
 */

export const APP_CONFIG = {
  // Exception Approval Emails
  DIRECTOR_EMAIL: 'vidhan.rohan@gmail.com',      // President/Director email
  SECRETARY_EMAIL: 'rvidhan@gmail.com',          // Secretary email
  
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_URL || 'http://localhost:1337',
  
  // UI Configuration
  APPROVAL_TIMEOUT_MS: 5000,
} as const;

/**
 * Get the email address for a given role
 */
export const getEmailForRole = (role: 'President' | 'Secretary'): string => {
  switch (role) {
    case 'President':
      return APP_CONFIG.DIRECTOR_EMAIL;
    case 'Secretary':
      return APP_CONFIG.SECRETARY_EMAIL;
    default:
      return '';
  }
};

/**
 * Extract role from sendExceptionApprovalTo string
 * Expected format: "President [Name]" or "Secretary [Name]"
 */
export const extractRoleFromApprovalString = (approvalString: string): 'President' | 'Secretary' | null => {
  if (approvalString.includes('President')) return 'President';
  if (approvalString.includes('Secretary')) return 'Secretary';
  return null;
};
